<template>
  <v-card class="rounded-sm convocatoria-modal-shell" color="primary">
    <v-card-text>
      <v-container>
        <v-form v-model="form" ref="form">
          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 ui-section-title">Información General</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.convocatoria"
                class="ui-form-field"
                label="Nombre de convocatoria"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Nombre de convocatoria <span class="red--text">*</span></template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="convocatoria.fk_idDirigidaA"
                class="ui-form-field"
                :items="dirigidos"
                item-value="id"
                item-text="title"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Dirigida a <span class="red--text">*</span></template>
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4 ui-section-title">Clasificación</div>
            </v-col>
            <v-col cols="12" :md="esPromocion ? 3 : 4">
              <v-select
                v-model="convocatoria.fk_idTipoConvocatoria"
                class="ui-form-field"
                :items="tiposConvocatoria"
                item-value="id"
                item-text="title"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Tipo de convocatoria <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12" :md="esPromocion ? 3 : 4">
              <v-select
                v-model="convocatoria.fk_idSubTipoConvocatoria"
                class="ui-form-field"
                :items="subtiposConvocatoria"
                item-value="id"
                item-text="title"
                :rules="required"
                :disabled="!convocatoria.fk_idTipoConvocatoria"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Subtipo de convocatoria <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col v-if="esPromocion" cols="12" md="3">
              <v-select
                v-model="convocatoria.fk_idGradoPromocion"
                class="ui-form-field"
                :items="gradosPromocion"
                item-value="id"
                item-text="title"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Grado a promocionar</template>
              </v-select>
            </v-col>
            <v-col cols="12" :md="esPromocion ? 3 : 4">
              <v-text-field
                v-model.number="convocatoria.plazasVacantes"
                class="ui-form-field"
                type="number"
                min="1"
                max="99"
                :rules="plazasVacantesRules"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              >
                <template v-slot:label>Número de plazas a promocionar <span class="red--text">*</span></template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4 ui-section-title">Requisitos y Beneficios</div>
            </v-col>
            <v-col cols="12">
              <v-expansion-panels v-model="panelAbierto" class="ui-textarea-panels" accordion flat>
                <v-expansion-panel>
                  <v-expansion-panel-header class="ui-panel-header">
                    Requisitos <span class="red--text ml-1">*</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-textarea
                      v-model="convocatoria.requisitos"
                      class="ui-form-textarea"
                      :rules="required"
                      rounded
                      filled
                      color="secondary"
                      background-color="transparent"
                      no-resize
                      rows="8"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="ui-panel-header">
                    Beneficios <span class="red--text ml-1">*</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-textarea
                      v-model="convocatoria.beneficios"
                      class="ui-form-textarea"
                      :rules="required"
                      rounded
                      filled
                      color="secondary"
                      background-color="transparent"
                      no-resize
                      rows="8"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="ui-panel-header">
                    Documentación <span class="red--text ml-1">*</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-textarea
                      v-model="convocatoria.documentacion"
                      class="ui-form-textarea"
                      :rules="required"
                      rounded
                      filled
                      color="secondary"
                      background-color="transparent"
                      no-resize
                      rows="8"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4 ui-section-title">Proceso de Selección</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.procedimientoSeleccion"
                class="ui-form-field"
                label="Procedimiento de selección"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.lugarRecepcionDocumentos"
                class="ui-form-field"
                label="Lugar de recepción de documentación"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4 ui-section-title">Fechas Importantes</div>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaPublicacion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaPublicacionFormatted"
                    class="ui-form-field"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha de publicación <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraPublicacionConvocatoria"
                  class="ui-date-picker"
                  @input="menuFechaPublicacion = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaRecepcion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaRecepcionFormatted"
                    class="ui-form-field"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Recepción documentos <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraRecepcionDocumentos"
                  class="ui-date-picker"
                  @input="menuFechaRecepcion = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaInicio"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaInicioFormatted"
                    class="ui-form-field"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha inicio registro <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraInicioRegistro"
                  class="ui-date-picker"
                  @input="menuFechaInicio = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuFechaCierre"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaCierreFormatted"
                    class="ui-form-field"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha cierre registro <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraCierreRegistro"
                  class="ui-date-picker"
                  @input="menuFechaCierre = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuFechaResultados"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaResultadosFormatted"
                    class="ui-form-field"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha de resultados <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraResultados"
                  class="ui-date-picker"
                  @input="menuFechaResultados = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center py-4 ui-module-actions">
      <TextButton color="secondary" :loading="loading" :disabled="!validForm || loading" @click="editarConvocatoria">
        Actualizar Convocatoria
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: { TextButton },

  props: {
    convocatoriaData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: false,
      loading: false,
      panelAbierto: 0,
      menuFechaPublicacion: false,
      menuFechaRecepcion: false,
      menuFechaInicio: false,
      menuFechaCierre: false,
      menuFechaResultados: false,
      convocatoria: {
        id: null,
        fk_idTipoConvocatoria: null,
        fk_idSubTipoConvocatoria: null,
        fk_idGradoPromocion: null,
        fk_idDirigidaA: null,
        convocatoria: '',
        beneficios: '',
        plazasVacantes: null,
        requisitos: '',
        documentacion: '',
        lugarRecepcionDocumentos: '',
        procedimientoSeleccion: '',
        fechaHoraRecepcionDocumentos: '',
        fechaHoraPublicacionConvocatoria: '',
        fechaHoraInicioRegistro: '',
        fechaHoraCierreRegistro: '',
        fechaHoraResultados: '',
      },
      required: [(v) => !!v || 'Este campo es requerido.'],
      plazasVacantesRules: [
        (v) => (v !== null && v !== undefined && v !== '') || 'Este campo es requerido.',
        (v) => Number.isInteger(Number(v)) || 'Debe ser un valor numérico.',
        (v) => (Number(v) >= 1 && Number(v) <= 99) || 'El valor debe estar entre 1 y 99.',
      ],
    }
  },

  async created() {
    await this.loadCatalogos()
    await this.cargarDatosConvocatoria()
  },

  computed: {
    ...mapGetters('convocatorias', {
      tiposConvocatoria: 'getTiposConvocatoria',
      subtiposConvocatoria: 'getSubtiposConvocatoria',
      gradosPromocion: 'getGradosPromocion',
      dirigidos: 'getDirigidos',
    }),
    esPromocion() {
      if (!this.convocatoria.fk_idTipoConvocatoria) return false
      const tipoSeleccionado = this.tiposConvocatoria.find((t) => t.id === this.convocatoria.fk_idTipoConvocatoria)
      return tipoSeleccionado?.title?.toLowerCase() === 'promoción'
    },
    validForm() {
      return (
        this.form &&
        this.convocatoria.plazasVacantes !== null &&
        this.convocatoria.plazasVacantes !== '' &&
        this.convocatoria.fechaHoraRecepcionDocumentos &&
        this.convocatoria.fechaHoraPublicacionConvocatoria &&
        this.convocatoria.fechaHoraInicioRegistro &&
        this.convocatoria.fechaHoraCierreRegistro &&
        this.convocatoria.fechaHoraResultados
      )
    },
    fechaPublicacionFormatted() {
      return this.convocatoria.fechaHoraPublicacionConvocatoria
        ? moment(this.convocatoria.fechaHoraPublicacionConvocatoria, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaRecepcionFormatted() {
      return this.convocatoria.fechaHoraRecepcionDocumentos
        ? moment(this.convocatoria.fechaHoraRecepcionDocumentos, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaInicioFormatted() {
      return this.convocatoria.fechaHoraInicioRegistro
        ? moment(this.convocatoria.fechaHoraInicioRegistro, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaCierreFormatted() {
      return this.convocatoria.fechaHoraCierreRegistro
        ? moment(this.convocatoria.fechaHoraCierreRegistro, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaResultadosFormatted() {
      return this.convocatoria.fechaHoraResultados
        ? moment(this.convocatoria.fechaHoraResultados, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
  },

  methods: {
    ...mapActions('convocatorias', [
      'updateConvocatoria',
      'fetchAllTiposConvocatoria',
      'fetchSubtiposConvocatoriaByTipo',
      'fetchAllGradosPromocion',
      'fetchAllDirigidos',
      'fetchAllConvocatorias',
    ]),

    async loadCatalogos() {
      try {
        await Promise.all([this.fetchAllTiposConvocatoria(), this.fetchAllGradosPromocion(), this.fetchAllDirigidos()])
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los catálogos')
      }
    },

    parseFechaFromAPI(fecha) {
      if (!fecha) return ''

      if (typeof fecha === 'string' && (fecha.includes('a. m.') || fecha.includes('p. m.'))) {
        const datePart = fecha.split(' ')[0]
        return moment(datePart, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }

      return moment(fecha).format('YYYY-MM-DD')
    },

    parseId(value) {
      if (value === null || value === undefined || value === '') return null
      const parsed = parseInt(value, 10)
      return isNaN(parsed) ? value : parsed
    },

    async cargarDatosConvocatoria() {
      if (!this.convocatoriaData) {
        console.warn('No hay datos de convocatoria para cargar')
        return
      }

      try {
        const fk_idTipoConvocatoria = this.convocatoriaData.catSubTipoConvocatoria?.fk_idTipoConvocatoria || null

        this.convocatoria.fk_idTipoConvocatoria = this.parseId(fk_idTipoConvocatoria)

        if (fk_idTipoConvocatoria) {
          await this.fetchSubtiposConvocatoriaByTipo(fk_idTipoConvocatoria)
          await this.$nextTick()
        }

        this.convocatoria = {
          ...this.convocatoria,
          id: this.parseId(this.convocatoriaData.id),
          fk_idSubTipoConvocatoria: this.parseId(this.convocatoriaData.fk_idSubTipoConvocatoria),
          fk_idGradoPromocion: this.parseId(this.convocatoriaData.fk_idGradoPromocion),
          fk_idDirigidaA: this.parseId(this.convocatoriaData.fk_idDirigidaA),
          convocatoria: this.convocatoriaData.convocatoria || '',
          beneficios: this.convocatoriaData.beneficios || '',
          plazasVacantes: this.convocatoriaData.plazasVacantes ? Number(this.convocatoriaData.plazasVacantes) : null,
          requisitos: this.convocatoriaData.requisitos || '',
          documentacion: this.convocatoriaData.documentacion || '',
          lugarRecepcionDocumentos: this.convocatoriaData.lugarRecepcionDocumentos || '',
          procedimientoSeleccion: this.convocatoriaData.procedimientoSeleccion || '',
          fechaHoraRecepcionDocumentos: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraRecepcionDocumentos),
          fechaHoraPublicacionConvocatoria: this.parseFechaFromAPI(
            this.convocatoriaData.fechaHoraPublicacionConvocatoria
          ),
          fechaHoraInicioRegistro: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraInicioRegistro),
          fechaHoraCierreRegistro: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraCierreRegistro),
          fechaHoraResultados: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraResultados),
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los datos de la convocatoria')
      }
    },

    async editarConvocatoria() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Por favor completa todos los campos requeridos')
        return
      }

      this.loading = true
      try {
        const payload = {
          fk_idSubTipoConvocatoria: this.convocatoria.fk_idSubTipoConvocatoria,
          fk_idGradoPromocion: this.convocatoria.fk_idGradoPromocion,
          fk_idDirigidaA: this.convocatoria.fk_idDirigidaA,
          convocatoria: this.convocatoria.convocatoria,
          beneficios: this.convocatoria.beneficios,
          plazasVacantes: String(this.convocatoria.plazasVacantes),
          requisitos: this.convocatoria.requisitos,
          documentacion: this.convocatoria.documentacion,
          lugarRecepcionDocumentos: this.convocatoria.lugarRecepcionDocumentos,
          procedimientoSeleccion: this.convocatoria.procedimientoSeleccion,
          fechaHoraPublicacionConvocatoria: this.convocatoria.fechaHoraPublicacionConvocatoria
            ? moment(this.convocatoria.fechaHoraPublicacionConvocatoria, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraRecepcionDocumentos: this.convocatoria.fechaHoraRecepcionDocumentos
            ? moment(this.convocatoria.fechaHoraRecepcionDocumentos, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraInicioRegistro: this.convocatoria.fechaHoraInicioRegistro
            ? moment(this.convocatoria.fechaHoraInicioRegistro, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraCierreRegistro: this.convocatoria.fechaHoraCierreRegistro
            ? moment(this.convocatoria.fechaHoraCierreRegistro, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraResultados: this.convocatoria.fechaHoraResultados
            ? moment(this.convocatoria.fechaHoraResultados, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
        }

        await this.updateConvocatoria({
          idConvocatoria: this.convocatoria.id,
          payload,
        })

        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Convocatoria actualizada correctamente')
        await this.fetchAllConvocatorias()
        this.$emit('close')
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar la convocatoria')
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    'convocatoria.fk_idTipoConvocatoria': {
      async handler(newVal, oldVal) {
        if (newVal && oldVal !== undefined && newVal !== oldVal) {
          this.convocatoria.fk_idSubTipoConvocatoria = null
          try {
            await this.fetchSubtiposConvocatoriaByTipo(newVal)
          } catch (error) {
            this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los subtipos')
          }
        }
      },
    },

    convocatoriaData: {
      handler() {
        this.cargarDatosConvocatoria()
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.convocatoria-modal-shell {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}

.ui-section-title {
  color: #e0e0e0 !important;
  font-weight: 700;
  letter-spacing: 0.01em;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-textarea textarea {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon,
::v-deep .ui-form-textarea .v-label,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon,
::v-deep .ui-form-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .ui-date-picker {
  background: #111827 !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.16);
}

::v-deep .ui-textarea-panels {
  background: transparent !important;
}

::v-deep .ui-textarea-panels .v-expansion-panel {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  margin-bottom: 10px;
}

::v-deep .ui-textarea-panels .v-expansion-panel::before {
  box-shadow: none !important;
}

::v-deep .ui-panel-header {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .ui-textarea-panels .v-expansion-panel-content__wrap {
  padding: 0 16px 16px;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
}
</style>
